import React from 'react'
import Facility from './Facility'

const Facilities = () => {
    return (
        <>
            <div id='facilities'></div>
            <article className='p-12 md:p-24 lg:p-32 mt-16 flex flex-col items-center justify-center text-center'>
                <h2 className='font-bold text-2xl md:text-3xl lg:text-4xl mb-2'>Travel Hassle-Free</h2>
                <p className='text-sm md:text-lg lg:text-xl text-[#22222f] mb-8 md:mb-14 lg:mb-20'>Your belongings are safe with us. <br />We will take care of it!</p>

                {/* We could use this value w-[360px] md:w-[640px] lg:w-[768px] */}
                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8'>
                    <Facility facility='1' heading='Easy Lock' description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod' />
                </div>

            </article>
        </>
    )
}

export default Facilities